import { Badge, IconButton } from "@mui/material";
import makeStyles from '@mui/styles/makeStyles';
import { styled } from "@mui/material/styles";

export const Wrapper = styled("div")(() => ({
  display: "flex",
  flexDirection: "row",
  alignItems: "center",
  gap: 12,

  borderRadius: 8,
  border: "1px solid #E4E7EC",
  padding: "4px 12px",
  height: 40,
}));

export const Placeholder = styled("span")(() => ({
  color: "#E4E7EC",
  fontFamily: "Manrope",
  fontSize: 14,
  lineHeight: "24px",
  fontWeight: 600,
}));

export const WrapperPlaceholder = styled("div")(() => ({
  display: "flex",
  flexDirection: "row",
  alignItems: "center",
  gap: 8,
}));

export const WrapperRightSide = styled("div")(() => ({
  position: "relative",
  display: "flex",
  flexDirection: "row",
  alignItems: "center",
  gap: 5,
}));

export const IconButtonStyled = styled(IconButton)(() => ({
  padding: "0 !important",
}));

export const BadgeComponent = styled(Badge)(() => ({
  cursor: "pointer",
  margin: "0 10px",
  "& > span": {
    backgroundColor: "#E4E7EC",
    color: "#475467",
    fontSize: 12,
    fontWeight: 600,
    lineHeight: "16px",
    letterSpacing: 0.5,
    fontFamily: "Manrope",
  },
}));

const styles = makeStyles(() => ({
  wrapper: {
    position: "relative",
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    gap: 5,
  },
  menu: {
    "& .MuiMenu-paper": {
      padding: "12px 0",
      display: "flex",
      flexDirection: "row",
      alignItems: "center",
      borderRadius: 12,
      top: "250px !important",
      left: "780px !important",
      boxShadow: "0px 1px 2px 0px rgba(0, 0, 0, 0.30), 0px 2px 6px 2px rgba(0, 0, 0, 0.15)",
      "& > .MuiMenu-list": {
        padding: 0,
      },
    },
  },
}));

export default styles;
